export default [
    '24 24',
    '<path d="M6 17L11 12L6 7M13 17L18 12L13 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]